var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12838_5723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5035 37.004C44.8287 37.004 44.1538 36.7457 43.6397 36.2316C42.6086 35.201 42.6086 33.5347 43.6397 32.5041L48.9651 27.1787C51.3932 24.7742 52.7269 21.5632 52.7269 18.1281C52.7269 11.0654 46.9797 5.31574 39.9146 5.31574C36.4819 5.31574 33.2709 6.6495 30.8722 9.06986L25.5386 14.403C24.508 15.4341 22.8417 15.4341 21.811 14.403C20.7804 13.3724 20.7804 11.706 21.811 10.6754L27.1364 5.3476C30.5266 1.93089 35.0666 0.0429688 39.9146 0.0429688C49.8876 0.0429688 57.9997 8.15511 57.9997 18.1281C57.9997 22.9814 56.1118 27.5185 52.6821 30.9169L47.3649 36.2316C46.8508 36.7457 46.1783 37.004 45.5035 37.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0857 58.042C8.11262 58.042 0.000488281 49.9298 0.000488281 39.9568C0.000488281 35.1035 1.88841 30.5664 5.31815 27.168L10.6353 21.8533C11.6664 20.8227 13.3323 20.8227 14.3634 21.8533C15.394 22.8839 15.394 24.5502 14.3634 25.5809L9.038 30.9062C6.60702 33.3107 5.27326 36.5217 5.27326 39.9568C5.27326 47.0195 11.0205 52.7692 18.0857 52.7692C21.5183 52.7692 24.7294 51.4354 27.128 49.0151L32.4616 43.682C33.4922 42.6509 35.1586 42.6509 36.1892 43.682C37.2198 44.7126 37.2198 46.3789 36.1892 47.4095L30.8638 52.7378C27.4736 56.154 22.9341 58.042 18.0857 58.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5889 26.0897C33.914 26.0897 33.2392 25.8315 32.7251 25.3174C31.6945 24.2867 31.6945 22.6204 32.7251 21.5898L37.6812 16.6337C38.7123 15.6026 40.3782 15.6026 41.4093 16.6337C42.4399 17.6643 42.4399 19.3306 41.4093 20.3612L36.4527 25.3174C35.9386 25.8315 35.2637 26.0897 34.5889 26.0897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.455 42.2241C17.7801 42.2241 17.1048 41.9658 16.5912 41.4517C15.5601 40.4207 15.5601 38.7548 16.5912 37.7237L21.5473 32.7676C22.5779 31.737 24.2443 31.737 25.2749 32.7676C26.306 33.7982 26.306 35.4646 25.2749 36.4952L20.3188 41.4517C19.8047 41.9658 19.1298 42.2241 18.455 42.2241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3629 58.042C54.688 58.042 54.0132 57.7837 53.4991 57.2696L0.77332 4.54338C-0.257773 3.51277 -0.257773 1.84641 0.77332 0.815801C1.80393 -0.215293 3.4698 -0.215293 4.5009 0.815801L57.2271 53.5416C58.2577 54.5727 58.2577 56.2385 57.2271 57.2696C56.713 57.7837 56.0377 58.042 55.3629 58.042Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12838_5723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink1);
export default __webpack_public_path__ + "static/media/link 1.b44b31dd9509fc0231e882420a7a8feb.svg";
export { ForwardRef as ReactComponent };